export enum MappedTheme {
	primary,
	topNavigationBarBackground,
	topNavigationBarText,
	bottomNavigationBarBackground,
	bottomNavigationBarActiveItem,
	bottomNavigationBarInactiveItem,
	webMainNavigationBarBackground,
	webMainNavigationBarActiveItem,
	webMainNavigationBarInactiveItem,
	webMainNavigationBarHoverIndicator,
	background1a,
	background1b,
	textOnThemedBackground,
	secondaryTextInThemedBackground,
	baseButtonDefault,
	baseButtonHover,
	baseButtonClicked,
	iconButtonIcon,
	baseButtonText,
	iconButtonSecondaryText,
	baseButtonDisabled,
	baseButtonDisabledText,
	inputFieldBackground,
	inputFieldIcon,
	inputFieldText,
	inputFieldPlaceholderText,
	inputFieldBorder,
	background2,
	textOnBackground2,
	uiCardBackground,
	uiCardText,
	uiCardSecondaryText,
	imageText,
	imageOverlay,
	textOnWhiteBackground,
	secondaryTextOnWhiteBackground,
	themedTextOnWhiteBackground,
	primaryButtonDefault,
	primaryButtonHover,
	primaryButtonClicked,
	primaryButtonText,
	secondaryButtonDefault,
	secondaryButtonBorder,
	secondaryButtonHover,
	secondaryButtonClicked,
	secondaryButtonText,
	textButton,
	disabledButton,
	disabledButtonText,
	uiElements,
	hyperLinkDefault,
	hyperLinkClicked,
	hyperLinkHover,
	chatBubble1,
	chatText1,
	chatBubble2,
	chatText2,
	selectedElement,
	hoveredElement,
	accentColor,
	systemColorSuccess,
	systemColorAttention,
	systemColorError,
	systemColorFocus,
}
